module.exports = __webpack_public_path__ + "static/img/taiHeImg3.adf1907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg3.jpg
// module id = Rmid
// module chunks = 2